import AuthHeader from "features/authHeader/AuthHeader";
import FullscreenContainer from "features/containers/FullscreenContainer";
import LoginForm from "features/login/LoginForm";

const Login: React.FC = () => {
  return (
    <FullscreenContainer sx={{ bgcolor: "primary.main" }}>
      <AuthHeader />
      <LoginForm />
    </FullscreenContainer>
  );
};

export default Login;
